import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

/**
 * 하위 메뉴 탭 라벨 — 선택된 탭(.Mui-selected)에만 앞의 활성화 아이콘이 표시됩니다.
 * 표시/숨김·크기·색상은 user/style/pages.css 의 .tabs.sub-menu 규칙에서 처리합니다.
 */
export default function SubMenuTabLabel({ text, style }) {
    return (
        <span className={'sub-menu-label'} style={style}>
            <CheckCircleIcon className={'tab-active-icon'}/>
            {text}
        </span>
    )
}
